import gal1 from './img/gal-1.jpeg'
import gal2 from './img/gal-2.jpeg'
import gal3 from './img/gal-3.jpeg'
import gal4 from './img/gal-4.jpeg'
import gal5 from './img/gal-5.jpeg'
import gal6 from './img/gal-6.jpeg'
import gal7 from './img/gal-7.jpeg'
import gal8 from './img/gal-8.jpeg'
import gal9 from './img/gal-9.jpeg'
import gal10 from './img/gal-10.jpeg'
import gal11 from './img/gal-11.jpeg'
import gal12 from './img/gal-12.jpeg'
import gal13 from './img/gal-13.jpeg'
import gal14 from './img/gal-14.jpeg'



export const galleryImage = [

    {
        id: 1,
        className: 'gallery__item--1',
        alt:'Gallery-image 1',
        img: gal1
    },
    {
        id: 2,
        className: 'gallery__item--2',
        alt:'Gallery-image 2',
        img: gal2
    },
    {
        id: 3,
        className: 'gallery__item--3',
        alt:'Gallery-image 3',
        img: gal3
    },
    {
        id: 4,
        className: 'gallery__item--4',
        alt:'Gallery-image 4',
        img: gal4
    },
    {
        id: 5,
        className: 'gallery__item--5',
        alt:'Gallery-image 5',
        img: gal5
    },
    {
        id: 6,
        className: 'gallery__item--6',
        alt:'Gallery-image 6',
        img: gal6
    },
    {
        id: 7,
        className: 'gallery__item--7',
        alt:'Gallery-image 7',
        img: gal7
    },
    {
        id: 8,
        className: 'gallery__item--8',
        alt:'Gallery-image 8',
        img: gal8
    },
    {
        id: 9,
        className: 'gallery__item--9',
        alt:'Gallery-image 9',
        img: gal9
    },
    {
        id: 10,
        className: 'gallery__item--10',
        alt:'Gallery-image 10',
        img: gal10
    },
    {
        id: 11,
        className: 'gallery__item--11',
        alt:'Gallery-image 11',
        img: gal11
    }, {
        id: 12,
        className: 'gallery__item--12',
        alt:'Gallery-image 12',
        img: gal12
    },
    {
        id: 13,
        className: 'gallery__item--13',
        alt:'Gallery-image 13',
        img: gal13
    },
    {
        id: 14,
        className: 'gallery__item--14',
        alt:'Gallery-image 14',
        img: gal14
    },
   
]
